import {AfterViewChecked, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewChildren, QueryList} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SharedModalService} from "@app/shared-modal/service/shared-modal.service";
import * as moment from "moment";
import {AuthService} from "@app/core";
import {ICsDropDown} from "@app/shared/cs-components/cs-components.interface";
import {CsDropDownService} from "@app/shared/cs-components/cs-drop-down/cs-drop-down.service";
import {CsIconClasses, CsImages} from "@app/shared/cs-components/cs-images.";
import {CsActivityLogFilterConfigService} from "@app/shared/cs-activity-log/cs-activity-log-filter-config.service";
import {PropertyViewService} from "@app/features/customers/customer/property-view/service/property-view.service";
import {AddOpportunityService} from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import {ScheduledActivityService} from "@app/features/scheduled-activities/services/scheduled-activities.service";
import {CsToastBoxService} from "@app/services";
import {CsActivityLogApiService} from "@app/shared/cs-activity-log/cs-activity-log-api.service";
import {CsActivityLogEventService} from "@app/shared/cs-activity-log/cs-activity-log-event.service";
import {DatePipe} from "@app/pipes";
import {TimelineDatePipe} from "@app/pipes/timeline-date.pipe";
@Component({
    selector: 'app-my-scheduled-activities',
    templateUrl: './my-scheduled-activities.component.html',
    styleUrls: ['./my-scheduled-activities.component.css']
})
export class MyScheduledActivitiesComponent implements OnInit, OnChanges, AfterViewChecked {
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Input() userId!: number;
    @Input() showScheduledModal:boolean;
    selectedTab = 'myActivity';
    activities = [];
    param :any = {
        'currentPage': 1,
        'pageLimit':10,
        'selectedTab': 'myActivity',
        'date' : "",
        'order' : 'DESC',
        'searchText': "" ,
        'field':'dateToShow',
        // 'type':'1,3,4,5',
        'recordType':'',
        'currentUser':this.userId
    };
    loading:boolean = true;
    customerType:string = 'customer';
    customerId:any;
    jobId:any;
    usersList:any= [];
    isLoadingMore: boolean = false;
    usersWritePermission:any;
    usersUpdatePermission:any;
    teamMembersConfig: ICsDropDown;
    @ViewChild('dropDownCustomRender') dropDownCustomRender: TemplateRef<any>;
    @ViewChild('dropDownCustomRenderCheckbox') dropDownCustomRenderCheckbox: TemplateRef<any>;
    selectedTeamMembers :any;
    @ViewChild('activitiesScroll') activitiesScroll!: ElementRef;
    scheduledActivityUpdateAccess: boolean;
    selectedActivity: any;
    opportunityTemplateId: any;
    selectedToMail:string = '';
    activityEmail: any;
    scheduled: boolean = true;
    opportunityId: any;
    recordModuleId: number;
    showEmailModal: any;
    opportunityCommunicationAccess: boolean;
    scheduledActivityWriteAccess:boolean;
    callEditData: any;
    showCallLogModal: boolean = false;
    showOpportunityCallLogModal = false;
    showActivityModal: boolean = false;
    editActivityData: any;
    checkTodayActivity: boolean = false;
    todayEmailActivity: any = null;
    selectedWidgetsType: any;
    isCommonRoute: boolean = false;
    screenType: any;
    activityEdit:boolean=false;
    activityList: any;
    assigneeList: any;
    recordBasedAssigneeList: any;
    scheduledActivityParams:any;
    listActivity: any = [
        {
            "id": 1,
            "name": "Call",
            "description": null
        },
        {
            "id": 2,
            "name": "Email",
            "description": null
        },
        {
            "id": 3,
            "name": "Meeting",
            "description": null
        },
        {
            "id": 4,
            "name": "Task",
            "description": null
        }
    ];
    recordType:Array<any> = [
        { 'id': '', text: "All" },
        { 'id': 'customer', text: "Customer", feature : 'Customer' },
        { 'id': 'opportunity', text: "Opportunity", feature : 'Opportunity' },
        { 'id': 'contract', text: 'Contract', feature : 'Contract' }
    ];
    subscriptions: any = {};
    showUndoMessage = false;
    oldSearchValue:string = '';
    assignedCount:number = 0;
    unassignedCount:number = 0;
    /** Tab label/tooltip use translation keys (translate pipe in template). */
    tabs: { id: string; labelKey: string; tooltipKey: string }[] = [
        { id: 'myActivity', labelKey: 'My activities', tooltipKey: 'Assigned activities' },
        { id: 'unassignedActivity', labelKey: 'Unassigned activities', tooltipKey: 'Unassigned activities' }
    ];
    /** Scroll position per tab so each tab keeps its own scroll (not combined). */
    tabScrollTops: Record<string, number> = {};
    /** Cached list data per tab so tab switch does not call APIs. */
    tabCache: Record<string, { activities: any[]; currentPage: number; hasMoreData: boolean }> = {};
    /** Master tag list (lazy-loaded once) and the "#" dropdown's currently matching subset. */
    hashtags: any[] = [];
    filteredTags: any[] = [];
    /** Tags selected as search chips (applied as the `tagIds` filter). */
    selectedTagFilters: any[] = [];
    showTagDropdown: boolean = false;
    private hashtagsLoaded: boolean = false;
    @ViewChild('dropdownWrapper') dropdownWrapper!: ElementRef;
    activeIndex: number = -1;
    hoveredIndex: number = -1;
    pointerInside: boolean = false;
    isKeyboardMode: boolean = true;
    @ViewChild('dropdownInput') dropdownInputs: ElementRef;
    isDropdownOpen: boolean = false;
    hasMoreData: boolean = true;
    scrollHeightBeforeLoadMore: number = 0;
    callRestrictValue:boolean = false;
    hasScrollbar: boolean = false;
    @ViewChild('callLogWrapper') callLogWrapperRef: ElementRef;
    @ViewChild('oppCallLogWrapper') oppCallLogWrapperRef: ElementRef;

    constructor(
        private router: Router,
        private activateRoute: ActivatedRoute,
        @Inject('ajsState') private ajsState,
        private sharedModalService: SharedModalService,
        private authService: AuthService,
        private csDropDownService: CsDropDownService,
        private dropdownConfig: CsActivityLogFilterConfigService,
        private propertyService: PropertyViewService,
        @Inject('confirmationBoxHelper') private confirmationBoxHelper,
        private opportunityService: AddOpportunityService,
        private scheduledActivityListService: ScheduledActivityService,
        @Inject('$scope') private ajsScope,
        private toast: CsToastBoxService,
        private _api: CsActivityLogApiService,
        private _alEvent: CsActivityLogEventService,
        private shortDate: DatePipe,
        private timelineDateTime: TimelineDatePipe,
    ) {
    }
    ngOnInit() {
        this.usersWritePermission = this.authService.permitted(['SetupJobUsers.writeaccess']) === true;
        this.usersUpdatePermission = this.authService.permitted(['SetupJobUsers.updateaccess']) === true;
        this.scheduledActivityUpdateAccess = this.authService.permitted(['ScheduleActivity.updateaccess']) === true;
        this.scheduledActivityWriteAccess = this.authService.permitted(['ScheduleActivity.writeaccess']) === true;
        const EmailAccess = this.authService.permitted(['SendEmail.writeaccess']) === true;
        const SMSAccess = this.authService.permitted(['SendSMS.writeaccess']) === true;
        if (EmailAccess || SMSAccess) {
            this.opportunityCommunicationAccess = true;
        }
        const JobsTabPermission = this.authService.permitted(['JobDashboard.readaccess']) === true;
        if (JobsTabPermission) {
            this.recordType.push({'id': 'job', 'text': "Job", 'feature': 'JobDashboard'});
        }
        this.param['selectedTab'] = 'myActivity';
        this.opportunityService.getListActivityType().subscribe(
            (data: any) => {
                const types = data.activityTypes.map((a: any) => a.id);
                this.param.type = types.join(',');
                this.scheduledActivityListService.getScheduleActivitySortPreference().subscribe(
                    (pref) => {
                        this.setListSortParams(pref);
                        if (this.showScheduledModal === true) {
                            this.onTabSelect('first');
                        }
                    },
                    () => {
                        this.setListSortParams(null);
                        if (this.showScheduledModal === true) {
                            this.onTabSelect('first');
                        }
                    }
                );
            }
        );
        this.opportunityService.getAssignee().subscribe((data: any) => {
            this.assigneeList = data;
        });

        this.subscriptions['reschedule'] = this.opportunityService.$opportunityNewSchedule.subscribe(data => {
            if (data) {
                this.editActivityData = 'reschedule';
                this.validateModalStatus('activity');
            }
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (!changes['showScheduledModal'] || this.showScheduledModal !== true) {
            return;
        }
        if (changes['showScheduledModal'].firstChange) {
            return;
        }
        this.selectedTab = 'myActivity';
        this.param['searchText'] = '';
        this.selectedTagFilters = [];
        this.showTagDropdown = false;
        this.filteredTags = [];
        this.scheduledActivityListService.getScheduleActivitySortPreference().subscribe(
            (pref) => {
                this.setListSortParams(pref);
                this.onTabSelect('first');
            },
            () => {
                this.setListSortParams(null);
                this.onTabSelect('first');
            }
        );
    }
    ngAfterViewInit() {
        this.checkScroll();
    }

    ngAfterViewChecked() {
        if (this.callLogWrapperRef && this.callLogWrapperRef.nativeElement &&
            this.callLogWrapperRef.nativeElement.parentElement !== document.body) {
            document.body.appendChild(this.callLogWrapperRef.nativeElement);
        }
        if (this.oppCallLogWrapperRef && this.oppCallLogWrapperRef.nativeElement &&
            this.oppCallLogWrapperRef.nativeElement.parentElement !== document.body) {
            document.body.appendChild(this.oppCallLogWrapperRef.nativeElement);
        }
    }

    @HostListener('window:resize')
    onResize() {
        this.checkScroll();
    }

    checkScroll() {
        const el = this.activitiesScroll.nativeElement;
        const hasScroll = el.scrollHeight > el.clientHeight;
        this.hasScrollbar = hasScroll;
        if (!hasScroll) {
            el.classList.add('no-scroll');
        } else {
            el.classList.remove('no-scroll');
        }
    }
    onListScreenClicks(){
        this.onClose.emit(false);
        this.router.navigateByUrl('/scheduled_activities')
    }

    getTabCount(tabId: string): number {
        return tabId === 'myActivity' ? this.assignedCount : this.unassignedCount;
    }

    /** Switch tab: save current scroll for this tab. If tab has cached data, use it (no API). Otherwise load from API. */
    selectTab(tabId: string) {
        if (this.callRestrictValue || this.selectedTab === tabId) return;
        const el = this.activitiesScroll && this.activitiesScroll.nativeElement;
        if (el) this.tabScrollTops[this.selectedTab] = el.scrollTop;
        this.selectedTab = tabId;
        this.onTabSelect('tabChanged');
        const cached = this.tabCache[tabId];
        if (cached) {
            this.param['selectedTab'] = tabId;
            this.param['currentPage'] = cached.currentPage;
            this.hasMoreData = cached.hasMoreData;
            this.activities = cached.activities;
            this.loading = false;
            this.isLoadingMore = false;
            setTimeout(() => {
                this.checkScroll();
                const scrollEl = this.activitiesScroll && this.activitiesScroll.nativeElement;
                if (scrollEl) {
                    const saved = this.tabScrollTops[tabId];
                    if (saved != null) requestAnimationFrame(() => { scrollEl.scrollTop = saved; });
                }
            }, 0);
            return;
        }
        // this.onTabSelect('tabChanged');
    }

    /** Saved sort from UserColumnPreferences (`schedule_activity_sort`), or list defaults. */
    private setListSortParams(pref: { field?: string; order?: string } | null): void {
        if (pref && pref.field && pref.order) {
            this.param.field = pref.field;
            this.param.order = pref.order;
        } else {
            this.param.field = 'dateToShow';
            this.param.order = 'DESC';
        }
    }

    onTabSelect(value){
        this.param['selectedTab'] = this.selectedTab;
        if(value == 'first' || value == 'tabChanged'){
            this.param['currentPage'] = 1;
            this.hasMoreData = true;
            this.param['searchText'] = (value === 'tabChanged') ? '' : this.param['searchText'];
            if (value === 'tabChanged') this.selectedTagFilters = [];
            if (value === 'first') delete this.tabCache[this.selectedTab];
        }
        this.param['currentUser'] = this.userId;
        this.param['tagIds'] = this.selectedTagFilters.map(tag => tag.id).join(',');
        this.loading = true;
        this.callRestrictValue = true
        const requestedForTab = this.selectedTab;
        const requestedPage = this.param.currentPage;
        this.sharedModalService.getFilterDatas(this.param).subscribe((response: any) => {
            if (this.selectedTab !== requestedForTab) return;
            if (response.hasOwnProperty('scheduledActivities')) {
                if (requestedPage === 1) {
                    this.activities = response.scheduledActivities; // Replace the list for the first page
                } else {
                    this.activities = [...this.activities, ...response.scheduledActivities]; // Append new data
                }
                // this.unassignedCount = response.unassignedCount;
                // this.assignedCount = response.assignedCount;
                this.usersList = response.usersList;
                this.activities.forEach(item => {
                    item.teamMembersConfig = this.parseUserDetails(item.assignees);
                    item.isAssignJobToLoggedInUser = this.checkCanAssignJobToLogedinUser(item.assignees);
                    item.showDropdown = false;
                });
                this.hasMoreData = response.scheduledActivities.length >= 10;
            }
            this.tabCache[requestedForTab] = {
                activities: [...this.activities],
                currentPage: requestedPage,
                hasMoreData: this.hasMoreData
            };
            this.loading = false;
            this.isLoadingMore = false;
            this.callRestrictValue = false;
            setTimeout(() => {
                this.checkScroll();
                const el = this.activitiesScroll && this.activitiesScroll.nativeElement;
                if (el) {
                    if (requestedPage > 1 && this.scrollHeightBeforeLoadMore > 0) {
                        requestAnimationFrame(() => {
                            el.scrollTop = this.scrollHeightBeforeLoadMore;
                            this.scrollHeightBeforeLoadMore = 0;
                        });
                    } else {
                        const saved = this.tabScrollTops[this.selectedTab];
                        if (saved != null) {
                            requestAnimationFrame(() => { el.scrollTop = saved; });
                        }
                    }
                }
            }, 0);
        });
        this.scheduledActivityListService.getScheduledActivitiesCount('myActivity').subscribe((data: any) => {
            this.assignedCount = data.assignedCount;
            this.unassignedCount = data.unassignedCount;
        });
    }

    /** Threshold in pixels from bottom to trigger load more (avoids subpixel/rounding issues) */
    private readonly scrollLoadThreshold = 50;

    onScroll(event: any) {
        const element = event.target;
        this.tabScrollTops[this.selectedTab] = element.scrollTop;
        if (this.isNearBottom(element)) {
            this.loadMoreData();
        }
    }

    /** Called on touchend so load-more works when user scrolls to bottom on touch devices */
    onTouchEnd() {
        const el = this.activitiesScroll && this.activitiesScroll.nativeElement;
        if (el && this.isNearBottom(el)) {
            this.loadMoreData();
        }
    }

    private isNearBottom(element: HTMLElement): boolean {
        if (!element || !element.scrollHeight) return false;
        const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;
        return distanceFromBottom <= this.scrollLoadThreshold;
    }

    loadMoreData() {
        if (this.isLoadingMore || !this.hasMoreData) return;
        const tabTotal = this.getTabCount(this.selectedTab);
        if (this.activities.length >= tabTotal) return;
        if (this.activitiesScroll && this.activitiesScroll.nativeElement) {
            this.scrollHeightBeforeLoadMore = this.activitiesScroll.nativeElement.scrollHeight;
        }
        this.isLoadingMore = true;
        this.param.currentPage += 1;
        this.onTabSelect('next');
    }

    ModifyActivityDate(date) {
        const mDate = moment(date);
        const today = moment().startOf('day');
        const endOfWeek = moment().endOf('week');
        const endOfNextWeek = moment().endOf('week').add(1, 'week');

        let shortDate: any = this.shortDate.transform(date);
        const cDate = moment.utc(date);
        let currentTime = this.timelineDateTime.transform(cDate,'datetime')
        let currentHourTime = currentTime.match(/\(([^)]+)\)/);
        let tooltipDate = `${shortDate} (${currentHourTime[1]})`;
        let label = '';

        // Past dates (including yesterday)
        if (mDate.isBefore(today, 'day')) {
            label = 'Overdue';
        }
        // Today
        else if (mDate.isSame(today, 'day')) {
            label = 'Due today';
        }
        // Tomorrow
        else if (mDate.isSame(today.clone().add(1, 'day'), 'day')) {
            label = 'Due tomorrow';
        }
        // This week (excluding today/tomorrow)
        else if (mDate.isSame(today, 'week')) {
            label = `Due ${mDate.format('dddd')}`; // e.g., "Due Friday"
        }
        // Next week
        else if (mDate.isAfter(endOfWeek) && mDate.isSameOrBefore(endOfNextWeek, 'day')) {
            label = 'Due next week';
        }
        // Beyond next week
        else {
            label = `Due ${mDate.format('Do MMM YYYY')}`;
        }

        return {
            label: label,
            tooltip: tooltipDate
        };
    }

    checkCanAssignJobToLogedinUser(assignees) {
        const userHasAccess = this.usersList.find(allow => String(allow.id) === String(this.userId));
        if (userHasAccess) {
            // const getSelectedMembers = this.csDropDownService.getItemsBy(this.teamMembersConfig, 'SELECTED');
            const userHasAssigned = assignees.find(user => String(user.id) === String(this.userId));

            if (userHasAssigned) {
                return false;
            }else {
                return true;
            }
        }
    }
    takeThisJob(Record) {
        let user = {id:this.userId};
        this.selectedTeamMember(user,Record);
        this.unassignedCount--;
        this.assignedCount++
        this.activities.forEach(item => {
            item.teamMembersConfig = this.parseUserDetails(item.assignees);
            item.isAssignJobToLoggedInUser = this.checkCanAssignJobToLogedinUser(item.assignees);
        });
        setTimeout(()=>{
            this.activities = this.activities.filter(item => item.activityId !== Record.activityId);
        },3000);
    }

    selectedTeamMember(item,activity){
        this.toggleAssignee(item.id,activity.activityId);
        if(item.id == this.userId && item.isSelected == false || (this.selectedTab == 'unassignedActivity')){
            this.onTabSelect('first');
        }
    }
    toggleAssignee(userId, activityId) {
        const activityConstant = { Call: 1, Email: 3, Meeting: 4, Task: 5 };
        this.activities = this.activities.map(activity => {
            if (String(activity.activityId) === String(activityId)) {
                const existsInActivity = activity.assignees.some(
                    a => String(a.id) === String(userId)
                );
                let updatedActivity;
                if (existsInActivity) {
                    // ✅ Remove user if exists
                    updatedActivity = {
                        ...activity,
                        assignees: activity.assignees.filter(
                            a => String(a.id) !== String(userId)
                        )
                    };

                    const payload = {
                        assigneeIds: [],
                        deletedAssigneeIds: [Number(userId)],
                        notes: updatedActivity.notes,
                        description: updatedActivity.description,
                        activityType: activityConstant[updatedActivity.activityType],
                        scheduled_date: updatedActivity.timeToShow,
                        scheduleId: updatedActivity.activityId,
                        activityUpdate: false
                    };
                    this.propertyService.saveEditScheduledActivity(payload, payload['scheduleId']).subscribe(value => {
                    });
                } else {
                    // ✅ Add user if not exists (from master user list)
                    const userToAdd = this.usersList.find(
                        u => String(u.id) === String(userId)
                    );
                    if (userToAdd) {
                        updatedActivity = {
                            ...activity,
                            assignees: [...activity.assignees, userToAdd]
                        };

                        const payload = {
                            assigneeIds: [Number(userId)],
                            deletedAssigneeIds: [],
                            notes: updatedActivity.notes,
                            description: updatedActivity.description,
                            activityType: activityConstant[updatedActivity.activityType],
                            scheduled_date: updatedActivity.timeToShow,
                            scheduleId: updatedActivity.activityId,
                            activityUpdate: false,
                        };
                        this.propertyService.saveEditScheduledActivity(payload, payload['scheduleId']).subscribe(value => {
                        });
                    }
                }
                return updatedActivity;
            }
            return activity;
        });

    }


    parseUserDetails(users ) {
        const selectedUsers = users.map(user => String(user.id));
        let config: any = this.formatDropDownConfig(this.usersList, 'user', selectedUsers, true);
        this.teamMembersConfig = config
        return this.teamMembersConfig;

    }
    formatDropDownConfig(configData: any, screenType: string, selectedId, checkIsSelected) {
        let textKey = 'name';
        let placement = 'left';
        let customRender: any = '';
        let isMultiChoice = false;
        let defaultData: any = {
            'text': '',
            'background': ''
        }
        if (screenType == 'team') {
            textKey = 'teamName'
        }
        else if (screenType == 'user') {
            textKey = 'username'
            placement = '';
            isMultiChoice = true;
            customRender = this.dropDownCustomRenderCheckbox
        }

        if (configData && configData.length) {
            let listData = [];
            configData.forEach(data => {
                let selected;
                if(selectedId && checkIsSelected){
                    selected = selectedId.findIndex(x => x == data.id);
                    if (selected === -1) {
                        selected = false;
                    } else {
                        selected = true;
                        defaultData.text = data[textKey];
                        defaultData.background = data['color'];
                    }
                } else {
                    selected = false;
                }
                listData.push({
                    id: data.id,
                    isSelected: selected,
                    templateData: {
                        text: data[textKey] ? data[textKey] : '',
                        background: data['color'] ? data['color'] : '',
                        iconsList: screenType == 'user' ? this.getIconConfiguration(data.profilepicture) : ''
                    }
                });

            });
            if(checkIsSelected) {
                return this.getCommonConfig(listData, defaultData, customRender, placement, isMultiChoice);
            } else {
                return listData;
            }
        }
    }


    getIconConfiguration(profilePic) {
        return [
            this.dropdownConfig.getIconConfig('check_box', CsIconClasses.squareCheckBox, false, 'CLASS_ICON'),
            this.dropdownConfig.getIconConfig('profile_pic', profilePic || CsImages.userProfile, false, 'IMAGE', 'CIRCLE')
        ];
    }

    getCommonConfig(listData, defaultData, customTemplate: any = '', placement, isMultiChoice) {
        return {
            id: 'dropdown_config',
            ddTogglerConfig: {
                templateType: 'CUSTOM',
                customTemplateRef: customTemplate ? customTemplate : this.dropDownCustomRender,
                ddPlacement: placement,
                templateData: {
                    text: defaultData.text ? defaultData.text : '',
                    background: defaultData.background ? defaultData.background : ''
                }
            },
            ddMenuConfig: {
                isSearchBar: true,
                isMultiChoice: isMultiChoice,
                templateType: 'BASIC',
                items: listData,
                customStyle: {right: '-8px'},
            }
        }
    }

    onRowSelect(data, event,selectedMail = null) {
        this.activities = this.activities.map(activity => {
            if (String(activity.activityId) === String(data.activityId)) {
                return {
                    ...activity,
                    isSelected: true
                };
            }
            return activity;
        });

        if(this.scheduledActivityUpdateAccess){
            if(data.recordType !== 'Opportunity' || (data.recordType === 'Opportunity')) {
                this.onSelectCheckbox({ data: data, isChecked: event.target.checked,selectedMail:selectedMail });
            }
        } else {
            this.onSelectEmail({ data: data, isChecked: event.target.checked, activityId: data.activityId, activityType: false,selectedMail:selectedMail  });
        }
        setTimeout(()=>{
            this.onTabSelect('first');
        },1000)

    }
    onSelectEmail(event) {
        let data = event.data;
        data.checked = event.isChecked;
        let activityType = data.activityType;
        this.selectedActivity = data;
        this.selectedToMail = (event.hasOwnProperty('selectedMail')) ? event.selectedMail : '';
        this.selectedActivity['isScheduled'] = true;
        this.opportunityTemplateId = this.selectedActivity.opportunityTemplateId;
        let id;
        id = event.activityId;
        let selectid = [];
        selectid.push(id)
        this.activityEmail = selectid;
        let customerId = this.selectedActivity['customerDetails'].customerId;
        this.customerId = customerId;
        this.opportunityId = data.opportunityId;
        this.recordModuleId = data['recordId'] || null;
        if (activityType == 'Email' || activityType == 'Call') {
            if (this.showEmailModal == true) {
                this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the email?', this.ajsScope)
                    .then(() => {
                        this.onModalClose('email');
                    }).catch(() => { });
            }
            else {
                if(this.selectedActivity.recordType !== 'Opportunity' || (this.selectedActivity.recordType === 'Opportunity' && this.opportunityCommunicationAccess)){
                    this.openEmailModal();
                }
            }
        }
    }

    onSelectCheckbox(event) {
        this.showUndoMessage = true;
        setTimeout(() => {
            this.showUndoMessage = false;
        }, 10000);
        let data = event.data;
        data.checked = event.isChecked;
        this.selectedActivity = data;
        this.scheduled=(this.selectedActivity.recordType == 'Opportunity') ? true : false;
        this.opportunityTemplateId = this.selectedActivity.opportunityTemplateId;
        this.selectedToMail = (event.hasOwnProperty('selectedMail')) ? event.selectedMail : '';
        let selectid = [];
        selectid.push(this.selectedActivity.activityId)
        this.activityEmail = selectid;
        if (this.selectedActivity['activityType'] == 'Email') {
            this.selectedActivity.checked = true;
        }
        else {
            this.selectedActivity.checked = true;
        }
        let customerId = this.selectedActivity['customerDetails'].customerId;
        this.customerId = customerId;
        this.opportunityId = data.opportunityId;
        this.recordModuleId = data['recordId'] || null;
        if (this.selectedActivity.checked) {
            if (data['activityType'] == 'Email') {
                if (this.showEmailModal == true) {
                    this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the email?', this.ajsScope)
                        .then(() => {
                            this.onModalClose('email');
                        }).catch(() => { });
                }
                else {
                    this.completeScheduledActivity(this.selectedActivity.activityId, this.selectedActivity)
                    if(this.selectedActivity.recordType !== 'Opportunity' || (this.selectedActivity.recordType === 'Opportunity' && this.opportunityCommunicationAccess)){
                        this.openEmailModal();
                    }


                }
            }
            else if (data['activityType'] == 'Call') {
                this.completeScheduledActivity(this.selectedActivity.activityId, this.selectedActivity)
                this.callEditData = null;
                if(this.selectedActivity.recordType !== 'Opportunity' || (this.selectedActivity.recordType === 'Opportunity' && this.opportunityCommunicationAccess)){
                    setTimeout(() => {
                        this.openCallModal();
                    }, 500);
                }
            }
            else if (data['activityType'] == 'Task') {
                if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
                    let activityData = { "activityIds": [this.selectedActivity.activityId] , "screen":this.selectedActivity.recordType };
                    this.opportunityService.completeScheduledActivity(activityData).subscribe(data => {
                        this.scheduledActivityListService.setRefreshActivityList(true);
                    });
                }
                else {
                    this.opportunityService.completeTask(this.selectedActivity.activityId).subscribe(
                        data => {
                            this.completeScheduledActivity(this.selectedActivity.activityId, this.selectedActivity)
                        }
                    )
                }
            }
            else {
                if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
                    let activityData = { "activityIds": [this.selectedActivity.activityId] , "screen":this.selectedActivity.recordType};
                    this.opportunityService.completeScheduledActivity(activityData).subscribe(data => {
                        this.scheduledActivityListService.setRefreshActivityList(true);
                    });
                }
                else {
                    this.opportunityService.completeMeeting(this.selectedActivity.activityId).subscribe(
                        data => {
                            this.completeScheduledActivity(this.selectedActivity.activityId, this.selectedActivity)
                        }
                    )

                }
            }
        }
    }

    onModalClose(type: string,clearExistingValue = true) {
        this.updateModalOpenCloseStatus(type, false);
        switch (type) {
            case 'call':
                this.showCallLogModal = false;
                this.showOpportunityCallLogModal = false;
                this.callEditData = '';
                break;
            case 'activity':
                this.showActivityModal = false;
                if(clearExistingValue){
                    this.editActivityData = '';
                }
                break;
            case 'email':
                this.showEmailModal = false;
                break;
        }
    }
    updateModalOpenCloseStatus(type, status) {
        type = type == 'Schedule activity' ? 'activity' : type;
        let screen = (type.toLowerCase() == 'email' || type.toLowerCase() == 'activity') ? 'others' : 'customer';
        return this.sharedModalService.updateModalStatus(screen, type, status);
    }

    openEmailModal() {
        this.todayEmailActivity = [];
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            let type = 'Email';
            this.checkTodayActivity = true;
            this.setScreenType();
            this.validateModalStatus(type);
        }
        else{
            this.setScreenType();
            let type = 'email';
            this.validateModalStatus(type)
        }

    }

    validateModalStatus(type){
        let modalStatusCheck = this.sharedModalService.checkModalStatus();
        if(modalStatusCheck){
            this.confirmationBoxHelper.getConfirmation(`Are you sure you want to discard the ${modalStatusCheck} ?`, this.ajsScope)
                .then(() => {
                    this.onModalClose(modalStatusCheck,false);
                    this.selectedWidgetsType = '';
                    this.commonModalRemoval();
                    if(modalStatusCheck == 'email'){
                        const emailParams = {
                            isFromJs: false,
                            showModal: false,
                        }
                        this.sharedModalService.setEmailModalDetails(emailParams)
                    }
                    setTimeout(() => {
                        this.modalSelection(type);
                    }, 500);

                });
        }else{
            this.selectedWidgetsType = '';
            this.modalSelection(type);
        }
    }

    setScreenType() {
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            this.isCommonRoute = true;
            this.screenType = this.selectedActivity.recordType.toLowerCase();
            if(this.screenType == 'job'){
                this.screenType = 'jobs';
            }
            this.customerType = 'customer';
        }
        else {
            this.isCommonRoute = false;
        }
    }

    completeScheduledActivity(activityId, activityDetails) {
        let activityData = { "activityIds": [activityId] ,'screen': activityDetails.recordType};
        if (activityDetails.recordType == "customer" || activityDetails.recordType == "job" || activityDetails.recordType === 'contract') {
            this.opportunityService.completeScheduledActivity(activityData).subscribe(data => {
                this.scheduledActivityListService.setRefreshActivityList(true);
                this.showToast('Scheduled activity completed');
            });
        }
        else {
            this.opportunityService.completeScheduleActivity(activityData).subscribe(
                data => {
                    this.scheduledActivityListService.setRefreshActivityList(true);
                    this.showToast('Scheduled activity completed');
                }
            )
        }
    }
    openCallModal() {
        this.activityList = [];
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            let type = 'Call';
            this.setScreenType();
            const moduleId = this.screenType === 'contract' ? this.recordModuleId : this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId;
            this.propertyService.getTodayScheduleActivity(moduleId, type, this.screenType).subscribe(
                (data: any) => {
                    this.activityList = data;
                    this.validateModalStatus(type)
                });
        }
        else if (this.opportunityCommunicationAccess) {
            this.setScreenType();
            let type = 'Call';
            this.validateModalStatus(type)
        }
    }
    commonModalRemoval() {
        if(!this.activityEdit){
            this.selectedWidgetsType = '';
            this.editActivityData = 'reschedule';
        }
        const params = {
            showActivityModal: false,
        };
        this.sharedModalService.setScheduledActivityDetails(params);
        const emailParams = {
            isFromJs: false,
            showModal: false,
        }
        this.sharedModalService.setEmailModalDetails(emailParams)
    }

    modalSelection(type){
        this.updateModalOpenCloseStatus(type, true);
        if(type.toLowerCase() == 'call'){
            this.selectedWidgetsType = 'call';
            if(this.selectedActivity.recordType === 'customer' || this.selectedActivity.recordType === 'job' || this.selectedActivity.recordType === 'contract') {
                this.showCallLogModal = true;
            } else if(this.selectedActivity.recordType === 'Opportunity') {
                this.showOpportunityCallLogModal = true;
            }
        }else if(type.toLowerCase() == 'activity'){
            this.openScheduleModal();
        }else if(type.toLowerCase() == 'email'){
            setTimeout(() => {
                this.triggerEmailModal();
            }, 300);
        }
    }

    openScheduleModal() {
        this.screenType = this.selectedActivity.recordType;
        if(this.screenType == 'job'){
            this.screenType = 'jobs'
        }
        this.recordBasedAssigneeList = this.assigneeList;
        const params = this.getScheduledActivityParams();
        this.sharedModalService.setScheduledActivityDetails(params);
    }

    triggerEmailModal() {
        this.screenType = this.selectedActivity.recordType;
        if(this.screenType == 'job'){
            this.screenType = 'jobs'
        }
        this.recordBasedAssigneeList = this.assigneeList;
        this.scheduledActivityParams = {
            tablePkId: this.screenType === 'contract' ? this.recordModuleId :this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId,
            screenType: this.screenType,
            isCommonRoute: this.isCommonRoute,
            showActivityModal: true,
            listActivity: this.listActivity,
            assigneeList: this.recordBasedAssigneeList,
            scheduledData: "reschedule",
            opportunityId:this.opportunityId
        }
        let customerType = (this.screenType != 'Opportunity') ? 2 : 232;
        if(this.screenType == 'jobs'){
            customerType = 31;
        }
        const contractTableTypeConstant = 301;

        if(this.screenType == 'Opportunity'){
            var opportunityAttachmentQuery = {
                limit : 1000,
                page :1,
                opportunityId: this.opportunityId,
                newEmailModal: true
            };
        }else{
            var attachmentQuery = {
                tableType:customerType,
                id: this.customerId,
            };
        }

        const customerQuery = {
            id: this.customerId,
            type : 'all_email',
        }

        const relatedObjectId = {
            customer: this.customerId,
            contract: this.recordModuleId,
            Opportunity: this.opportunityId,
            job: this.selectedActivity.recordId,
            jobs: this.selectedActivity.recordId
        };

        const params = {
            attachments_url: (this.screenType != 'Opportunity') ? ('get_attached_files_list?' + this.sharedModalService.mapQueryParams(attachmentQuery)) : ('getAttatchedFiles/'+this.opportunityTemplateId+'?' + this.sharedModalService.mapQueryParams(opportunityAttachmentQuery)),
            from_addresses_url: '/get_from_emails',
            isFromJs: false,
            showModal: true,
            relatedObjectType: (this.screenType === 'contract') ? contractTableTypeConstant : customerType,
            relatedObjectId: relatedObjectId[this.screenType],
            screenType: this.screenType.toLowerCase(),
            customerId: this.customerId,
            scheduledActivityParams : this.scheduledActivityParams,
            todayEmailActivity: this.todayEmailActivity,
            recipient_addresses_url: 'get_customer_emailaddresses?' + this.sharedModalService.mapQueryParams(customerQuery),
            selectedToEmail: this.selectedToMail,
            completeTodayActivity:true
        };
        this.sharedModalService.setEmailModalDetails(params);
    }
    showToast(msg) {
        this.toast.show(msg, 1500);
    }
    getScheduledActivityParams(){
        const params = {
            isCommonRoute: this.isCommonRoute,
            showActivityModal: true,
            listActivity: this.listActivity,
            assigneeList: this.recordBasedAssigneeList,
            scheduledData: this.editActivityData,
            tablePkId: this.screenType === 'contract' ? this.recordModuleId : this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId,
            screenType: this.screenType,
            opportunityId:this.opportunityId
        };
        return params;
    }

    onCallLogSave(event) {
        this.updateModalOpenCloseStatus('call', false);
        if (this.selectedActivity.recordType == "customer" || this.selectedActivity.recordType == "job" || this.selectedActivity.recordType === 'contract') {
            let isScheduled = event.isScheduled;
            let activityIds:any = [];
            const moduleId = this.selectedActivity.recordType === 'contract' ? this.recordModuleId : this.selectedActivity.recordType == "job" ? this.selectedActivity.recordId : this.customerId ;

            if(event.hasOwnProperty('activityIds') && event.activityIds.length){
                if (this.selectedActivity.recordType === 'contract' || this.selectedActivity.recordType === 'job' || this.selectedActivity.recordType === 'customer') {
                    activityIds = event.activityIds;
                } else {
                    event.activityIds.forEach((val,key) => {
                        activityIds.push(val.activityId);
                    });
                }
                let activityData = {"activityIds": activityIds,'screen': this.selectedActivity.recordType};

                this.opportunityService.completeScheduledActivity(activityData).subscribe(
                    data => {
                        this.showToast('Call log added and today call log activity is completed');
                    }, (error: any) => {
                        console.error('error', error);
                    });
            }

            let callLogData: any = new FormData;
            callLogData.append('communication[tablepkid]', moduleId);
            callLogData.append('communication[phonecall][calltype]', event.callType);
            callLogData.append('communication[phonecall][contacttelephoneid]', event.contactTelephoneId);
            callLogData.append('communication[phonecall][note]', event.note);

            if (this.selectedActivity.recordType === 'contract') {
                this._api.saveCallLog(
                    this.customerType,
                    this.customerId,
                    this.selectedActivity.recordType,
                    moduleId,
                    callLogData
                ).subscribe(data => {
                    if (data) {
                        if (isScheduled) {
                            this.opportunityService.setNewReschedule(isScheduled)
                        }
                        this.onModalClose('call');
                    }
                });
            } else {
                this.propertyService.saveCallLog(this.customerId, this.customerType, this.customerId, this.screenType, callLogData).subscribe((data: any) => {
                    if (data) {
                        if (isScheduled) {
                            this.opportunityService.setNewReschedule(isScheduled)
                        }
                        this.onModalClose('call');
                    }
                });
            }
        }
        else {
            if (event == true) {
                this.opportunityService.setNewReschedule(event);
            }
        }
        this.opportunityService.loadActivityList(true)
    }
    ngOnDestroy() {
        Object.keys(this.subscriptions).forEach((subscription) => this.subscriptions[subscription].unsubscribe());
    }
    undoCompleted() {
        this.showUndoMessage = false;
        this.setScreenType();
        let activityData:any = {"activityIds": [this.selectedActivity.activityId]};
        const { teamMembersConfig, ...plainActivity } = this.selectedActivity;
        let record = JSON.parse(JSON.stringify(plainActivity));
        record['activityCompleted'] = false;
        record['checked'] = false;
        if (!this.isCommonRoute) {
            this.opportunityService.undoScheduleActivity(activityData).subscribe(
                data => {
                    this.opportunityService.setRefreshActivityList(true);
                    this.selectedActivity.status = 'Pending';
                    this.opportunityService.setCompleteActivityDetails(record);
                    if (data['opportunityStatus'] != '') {
                        this.opportunityService.setOpportunityStatus(data['opportunityStatus']);
                    }
                    this.onTabSelect('first');
                }, (error: any) => {
                    console.error('error', error);
                }
            )
        }
        else{
            activityData.undo = true;
            this.opportunityService.completeScheduledActivity(activityData).subscribe(
                (data:any) => {
                    this.opportunityService.setRefreshActivityList(true)
                    this.selectedActivity.status = 'Completed';
                    record.undo = true;
                    this.opportunityService.setCompleteActivityDetails(record)
                    this.propertyService.setRefreshSliderScheduleActivity(true);
                    this._alEvent.notifyScheduledActivityCompletion(record);
                    this.onTabSelect('first');
                }, (error: any) => {
                    console.error('error', error);
                })
        }
    }

    onSearch(){
        // Still composing a "#tag" mention (dropdown open) - don't run a real free-text search on it.
        if (/#\w*$/.test(this.param.searchText)) {
            return;
        }
        if((this.param.searchText != '' && this.param.searchText.length > 1) || (this.oldSearchValue.length >1 && this.oldSearchValue != '' && this.param.searchText == '')){
            this.oldSearchValue = this.param.searchText;
            this.onTabSelect('first')
        }
    }

    onCloseModal(){
        this.onClose.emit(false);
    }
    clearSearch(){
        this.param.searchText = '';
        this.showTagDropdown = false;
        this.onSearch();
    }

    /** Detects "#word" being typed in the search box and opens a filtered tag dropdown (mirrors the
     * "@" user-mention pattern used on the Jobs page search bar). */
    onSearchInput(event: any) {
        const text: string = event.target.value || '';
        const hashIndex = text.lastIndexOf('#');
        if (hashIndex === -1) {
            this.showTagDropdown = false;
            return;
        }
        const match = text.match(/#(\w*)/);
        const term = (match ? match[1] : '').toLowerCase();
        if (!this.hashtagsLoaded) {
            this.hashtagsLoaded = true;
            this.sharedModalService.getHashTagsList().subscribe((response: any) => {
                this.hashtags = response.hashtags || [];
                this.updateFilteredTagDropdown(term);
            });
        } else {
            this.updateFilteredTagDropdown(term);
        }
    }

    private updateFilteredTagDropdown(term: string) {
        this.filteredTags = this.hashtags.filter((tag: any) =>
            tag.description.toLowerCase().includes(term) &&
            !this.selectedTagFilters.find(t => t.id == tag.id)
        );
        this.showTagDropdown = this.filteredTags.length > 0;
    }

    selectTagFilter(tag: any) {
        if (!this.selectedTagFilters.find(t => t.id == tag.id)) {
            this.selectedTagFilters.push(tag);
        }
        this.param.searchText = this.param.searchText.replace(/#(\w*)$/, '');
        this.showTagDropdown = false;
        this.onTabSelect('first');
    }

    removeTagFilter(tag: any) {
        this.selectedTagFilters = this.selectedTagFilters.filter(t => t.id != tag.id);
        this.onTabSelect('first');
    }

    onTagSelected(tag: any, activity: any) {
        this.activities.map(activite => {
            if (String(activite.activityId) === String(activity.activityId)) {
                return{
                    ...activite,
                    tagsList: [...activite.tagsList, tag]
                };
            }
            return activite;
        });
        let tagValue = [];
        tagValue.push(tag.description)
        const data = {activityId : activity.activityId, tags: tagValue};
        this.sharedModalService.saveActivityTag(data).subscribe( (data:any) => {
        })
    }

    onTagRemoved(tag: any, activity: any) {
        this.activities = this.activities.map(activite => {
            if (String(activite.activityId) === String(activity.activityId)) {
                return{
                    ...activite,
                    tagsList: activite.tagsList.filter((t: any) => t.id != tag.id)
                };
            }
            return activite;
        });
        let tagValue = [];
        tagValue.push(tag.id)
        const data = {activityId : activity.activityId, tagId: tagValue};
        this.sharedModalService.removeActivityTag(data).subscribe( (data:any) => {
        })
    }

}
